import CityPageTemplate from "../city-template/CityPageTemplate";
import { hendersonConfig } from "./data";

export default function HendersonPage() {
  return <CityPageTemplate config={hendersonConfig} />;
}